export const ScreenLayoutDefault = {
    'rColumn': {
        'visible': true,
        'rows': [
            {
                'visible': true,
                'size': 70
            },
            {
                'visible': true,
                'size': 30
            }
        ],
        'size': 25
    },
    'lColumn': {
        'visible': true,
        'rows': [
            {
                'visible': true,
                'size': 33.333333333333333
            },
            {
                'visible': true,
                'size': 33.333333333333333
            },
            {
                'visible': true,
                'size': 33.333333333333333
            }
        ],
        'size': 25
    },
    'cColumn': {
        'visible': true,
        'rows': [
            {
                'visible': true,
                'size': 38.2313831677214
            },
            {
                'visible': true,
                'size': 61.7686168322786
            }
        ],
        'size': 50
    }
};
